import React, { isValidElement, useEffect, useRef } from "react"
import Typography from "../UI/Typography/Typography"
import * as style from "./AccordionWrapper-tw-styles"
import PropTypes from "prop-types"
import Button from "../UI/Button/Button"
import Link from "../UI/Link/Link"
import { gaEventClick } from "../../constants/gtm.constants"
import Image from "../UI/Image/Image"
import { get, scrollIntoViewIfNeeded } from "../../helpers/utils"
import useImage from "../../hooks/useImage"
import variants from "../../constants/variants.constants"

const AccordionItem = (props) => {
  const { content = {}, active = false, onToggle, changeImage, variant } = props
  const styles = style[variant] || style.defaultStyle
  const { title, description, shortDescription, data = {}, linkButton, mainImage, relatedItems, imagesCollection, endNotes } = content
  const contentRef = useRef(null)
  const { altText, foregroundImg, backgroundImg } = useImage(mainImage)
  const images = get(imagesCollection, "items", [])

  // Replacing accordion group image with accordion item image when accordion is active using changeImage callback function
  useEffect(() => {
    if (changeImage && foregroundImg && active) {
      changeImage(foregroundImg)
    }
  }, [active, foregroundImg, changeImage])
  
  return (
    <li className={styles?.accordianBtn} id={title} data-testid={title}>
      <div className={styles?.accordianList}>
        <Button
          className={
            `${styles.accordionTitle} ${active ? styles?.accordianListActive : styles?.accordianListInactive}`
          }
          onClick={e => {
            // Reverting back to accordion group image when user closes accordion
            if (changeImage && foregroundImg && active) {
              changeImage()
            }

            onToggle()
            
            if(variant === variants.TREND_RADAR_MOBILE_ACCORDION && !active){
              setTimeout(() => scrollIntoViewIfNeeded(e.target), 800);
            }
          }
          }
          dataActionDetail={title}
          gaEventClass={gaEventClick}
        >
          {title}
          <span
            className={
              active ? styles?.accordianIconMinus : styles?.accordianIconPlus
            }
          ></span>
        </Button>
        <div
          ref={contentRef}
          className={`${styles?.accordianWrapper} ${active ? styles?.activeAccordianWrapper : ""}`}
          style={
            variant?.startsWith("TREND_RADAR_CHART") ? {} :
              active
                ? { height: contentRef.current.scrollHeight, opacity: 1 }
                : { height: "0px", opacity: 0 }
          }
          data-testid="AccordionItem-accordionWrapper"
        >
          <div className={styles?.accordianWrapperContent}>
            <div className={styles?.accordianContent}>
              {typeof description === "string" ? (
                <Typography content={description} allow_br_tag={true} />
              ) : (
                description({ data: data })
              )}
              {shortDescription && <Typography className={styles?.shortDescription} content={shortDescription} allow_br_tag={true} />}
              {images?.length > 0 && <div className={styles?.accordionItemImages}>
                {images.map((image, i) => <Image key={i} contentfulImage={image} />)}
              </div>}
              {linkButton && (
                <Link {...linkButton} className={styles?.textLink} />
              )}
              {endNotes?.content && (variant!==variants.TREND_RADAR_MOBILE_ACCORDION || active) &&
                <Typography
                  className={styles?.endNotesAccordionItem}
                  content={endNotes.content}
                  id={endNotes.elementId} allow_br_tag={true} />
              }
              {isValidElement(relatedItems) && relatedItems}
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}

AccordionItem.propTypes = {
  content: PropTypes.object,
  active: PropTypes.bool,
  onToggle: PropTypes.func,
  changeImage: PropTypes.func,
  variant: PropTypes.string,
}

export default AccordionItem
